<template>
    <div>
        <div class="main-content bg-white" v-if="$currentUser.role == 'account'">
            <span class="alert-danger">У вас нет доступа к этой странице.</span>
        </div>
        <div class="main-content bg-white" v-if="$currentUser.role != 'account'">
            <div class="page-header">
                <h3 class="page-title">Источники</h3>
            </div>
            <div class="row mb-2">
                <div class="col-sm-4 col-md-3 col-lg-3 col-xl-2">
                    <b-btn size="sm" variant="success" style="white-space: nowrap;" class="mainButton filterComponent"
                           v-b-modal.createSource>
                        Создать источник
                        <!--<i class="icon-fa icon-fa-pencil"></i>-->
                    </b-btn>
                </div>
            </div>
            <div class="row mb-2">
                <div class="col-sm-4 col-md-3 col-lg-2 col-xl-2 mb-2">
                    <b-form-input placeholder="Поиск:"
                                  size="sm"
                                  class="filterComponent"
                                  v-model="search"></b-form-input>
                </div>
                <div class="col-sm-4 col-md-3 col-lg-2 col-xl-2 mb-2">
                    <b-form-select v-model="user"
                                   size="sm"
                                   class="filterComponent"
                                   :options="users">
                        <option :value="null" disabled>Создатель</option>
                    </b-form-select>
                </div>
                <div class="col-sm-4 col-md-3 col-lg-2 col-xl-2 mb-2">
                    <v-select :options="groups" required v-model="group"
                              class="filterComponent groupComponent"
                              placeholder="Группа"
                              multiple>
                        <span slot="no-options">Совпадений не найдено.</span>
                    </v-select>
                </div>

                <div class="col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2">
                    <b-button-group :key="dateRange" v-if="isXl" class="datePickerXl filterComponent">
                        <vue-rangedate-picker
                                :value="range"
                                placeholder="select"
                                :months="months"
                                :shortDays="shortDays"
                                :captions="captions"
                                @selected="selectRange($event)"
                                v-model="range"
                                format="DD.MM.YY"
                                :presetRanges="ranges"
                                i18n="EN">
                        </vue-rangedate-picker>
                        <b-button size="sm" variant="primary">
                            <i class="icon-fa icon-fa-calendar-check-o"></i>
                        </b-button>
                    </b-button-group>

                    <b-input-group :key="dateRange" v-if="!isXl" class="filterComponent">
                        <div></div>
                        <b-input-group-append>
                            <datepicker input-class="form-control dateFrom"
                                        class="date dateLeft"
                                        size="sm"
                                        monday-first
                                        v-model="range.start"
                                        :language="ru"
                                        placeholder="С:">
                            </datepicker>
                            <datepicker input-class="form-control dateTo"
                                        class="date dateRight"
                                        monday-first
                                        size="sm"
                                        v-model="range.end"
                                        :language="ru"
                                        placeholder="По:">
                            </datepicker>
                        </b-input-group-append>
                    </b-input-group>
                </div>
                <div class="myOffers col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2">
                    <b-form-checkbox value="on"
                                     style="display: inline !important;"
                                     class="onlyMyCheckbox filterComponent"
                                     v-model="onlyMy">
                        Мои источники
                    </b-form-checkbox>
                </div>
                <div class="col-sm-5 col-md-3 col-lg-2 col-xl-2 mb-2 applyButton">
                    <b-input-group class="filterComponent">
                        <div></div>
                        <b-input-group-append>
                            <b-btn size="sm" text="Search" variant="success"
                                   class="mainButton"
                                   style="margin-right: 4px; border-top-left-radius: 0.2rem; border-bottom-left-radius: 0.2rem;"
                                   @click="getSources(1, {sortBy: sortBy, sortDesc: sortDesc}, search, user)">
                                Применить
                                <!--<i class="icon-fa icon-fa-search"></i>-->
                            </b-btn>
                            <b-btn size="sm" variant="outline-danger" class="mainButton" @click="resetFilters">Очистить
                                <!--<i class="icon-fa icon-fa-times"></i>-->
                            </b-btn>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div v-if="!isMobile">
                        <b-table hover responsive bordered
                                 small
                                 :items="sources"
                                 :fields="fields"
                                 no-local-sorting
                                 :sort-by.sync="sortBy"
                                 @sort-changed="getSources(1, $event, search)"
                                 :sort-desc.sync="sortDesc"
                                 :sort-direction="sortDirection">
                            <template v-slot:cell(actions)="row">
                                <b-button size="sm" class="btn btn-warning"
                                          @click.stop="edit(row)">
                                    <i class="icon-fa icon-fa-edit"></i>
                                </b-button>
                                <b-button size="sm" class="btn btn-danger"
                                          v-if="row.item.user_id == $currentUser.id || $currentUser.role == 'admin'"
                                          @click.stop="deleteSource(row.item)">
                                    <i class="icon-fa icon-fa-trash-o"></i>
                                </b-button>
                            </template>
                        </b-table>
                    </div>
                    <div v-if="isMobile">
                        <b-table hover responsive bordered stacked
                                 small
                                 :items="sources"
                                 :fields="fields"
                                 no-local-sorting
                                 :sort-by.sync="sortBy"
                                 @sort-changed="getSources(1, $event, search)"
                                 :sort-desc.sync="sortDesc"
                                 :sort-direction="sortDirection">
                            <template v-slot:cell(user_id)="row">
                                <div>{{row.item.user.name}}</div>
                            </template>
                            <template v-slot:cell(actions)="row">
                                <b-button size="sm" class="btn btn-warning"
                                          @click.stop="edit(row)">
                                    <i class="icon-fa icon-fa-edit"></i>
                                </b-button>
                                <b-button size="sm" class="btn btn-danger"
                                          v-if="row.item.user_id == $currentUser.id || $currentUser.role == 'admin'"
                                          @click.stop="deleteSource(row.item)">
                                    <i class="icon-fa icon-fa-trash-o"></i>
                                </b-button>
                            </template>
                        </b-table>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-5">
                    <div class="" role="status" aria-live="polite">Всего записей: {{ pager.total }}</div>
                </div>
                <div class="col-sm-7">
                    <div class="float-right">
                        <nav aria-label="Page navigation">
                            <ul class="pagination justify-content-center">
                                <b-pagination size="sm" :total-rows="pager.total"
                                              v-model="pager.current_page"
                                              v-on:change="getSources($event, {sortBy: sortBy, sortDesc: sortDesc}, search)"
                                              :per-page="pager.per_page"></b-pagination>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
            <b-modal id="createSource"
                     :no-close-on-backdrop="true"
                     :no-enforce-focus="true"
                     :no-close-on-esc="true"
                     ref="sourceCreateModal" size="md" title="Создать источник" @hidden="hideCreateModal"
                     hide-footer>
                <CreateSourceModal></CreateSourceModal>
            </b-modal>

            <b-modal ref="sourceEditModal"
                     :no-close-on-backdrop="true"
                     :no-enforce-focus="true"
                     :no-close-on-esc="true"
                     id="sourceEditModal" size="md" title="Редактировать источник" hide-footer>
                <EditSourceModal v-bind:source="selectedSource"
                                 v-bind:editable="canEditSource(selectedSource)"></EditSourceModal>
            </b-modal>
        </div>
    </div>
</template>
<script>
    import VueRangedatePicker from '../../services/customVueRangedatePicker/dist/vue-rangedate-picker'
    import CreateSourceModal from './modals/CreateSourceModal.vue'
    import OffersService from '../../services/offersDataService'
    import EditSourceModal from './modals/EditSourceModal.vue'
    import SourcesService from '../../services/sourcesDataService'
    import {ru} from '../../services/customLocaleDatepicker'
    import Datepicker from 'vuejs-datepicker'

    export default {
        name: 'sources',
        components: {
            VueRangedatePicker: VueRangedatePicker,
            CreateSourceModal: CreateSourceModal,
            EditSourceModal: EditSourceModal,
            Datepicker: Datepicker,
        },
        data() {
            return {
                sources: [],
                groups: [],
                group: [],
                pager: {},
                user: null,
                users: [],
                onlyMy: false,
                pageSize: 50,
                fields: [
                    {
                        key: 'id',
                        label: 'ID',
                        sortable: true
                    },
                    {
                        key: 'title',
                        label: 'Название',
                        sortable: true
                    },
                    {
                        key: 'group',
                        label: 'Группа',
                        sortable: true
                    },
                    {
                      key: 'email',
                      label: 'Емейл',
                      sortable: false
                    },
                    {
                        key: 'user_name',
                        label: 'Создатель',
                        sortable: true
                    },
                    {
                        key: 'created_at',
                        label: 'Дата создания',
                        sortable: true
                    },
                    {
                        key: 'actions',
                        label: 'Действия',
                        tdAttr: {'align': "center"}
                    }
                ],
                search: '',
                sortBy: 'created_at',
                sortDesc: true,
                sortDirection: 'desc',
                ranges: {
                    today: function () {
                        let n = new Date();
                        const today = new Date(Date.UTC(n.getFullYear(), n.getMonth(), n.getDate(), 0, 0))

                        return {
                            label: 'Сегодня',
                            active: false,
                            dateRange: {
                                start: today,
                                end: today
                            }
                        }
                    },
                    yesterday: function () {
                        let n = new Date();
                        const yesterday = new Date(Date.UTC(n.getFullYear(), n.getMonth(), n.getDate() - 1, 0, 0))

                        return {
                            label: 'Вчера',
                            active: false,
                            dateRange: {
                                start: yesterday,
                                end: yesterday
                            }
                        }
                    },
                    thisMonth: function () {
                        let n = new Date();
                        let startMonth = new Date(Date.UTC(n.getFullYear(), n.getMonth(), 1));
                        let endMonth = new Date(Date.UTC(n.getFullYear(), n.getMonth() + 1, 0));

                        return {
                            label: 'Текущий месяц',
                            active: false,
                            dateRange: {
                                start: startMonth,
                                end: endMonth
                            }
                        }
                    },
                    lastMonth: function () {
                        let n = new Date();
                        let startMonth = new Date(Date.UTC(n.getFullYear(), n.getMonth() - 1, 1));
                        let endMonth = new Date(Date.UTC(n.getFullYear(), n.getMonth(), 0));

                        return {
                            label: 'Предыдущий месяц',
                            active: false,
                            dateRange: {
                                start: startMonth,
                                end: endMonth
                            }
                        }

                    },
                    allTime: function () {
                        let n = new Date();

                        let start = new Date("2018-01-01");
                        let startDate = new Date(Date.UTC(start.getFullYear(), start.getMonth(), start.getDate(), 0, 0))
                        let todayDate = new Date(Date.UTC(n.getFullYear(), n.getMonth(), n.getDate(), 0, 0))

                        return {
                            label: 'Всё время',
                            active: false,
                            dateRange: {
                                start: startDate,
                                end: todayDate
                            }
                        }
                    },
                },
                months: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль',
                    'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
                shortDays: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'],
                range: {
                    start: null,
                    end: null
                },
                captions: {
                    title: 'Выбрать даты',
                    ok_button: 'Применить'
                },
                dateRange: 0,
                selectedSource: null,
                isMobile: false,
                window: {
                    width: 0,
                    height: 0
                },
                isXl: false,
                ru: ru,
            }
        },
        methods: {
            getSources(page, sort, search, user) {
                if (!page) {
                    page = 1;
                }

                if (!sort) {
                    sort = this;
                }
                let range = {
                    end: null,
                    start: null
                };

                range.end = this.range.end ? new Date(this.range.end).toISOString().substring(0, 10) : null;
                range.start = this.range.start ? new Date(this.range.start).toISOString().substring(0, 10) : null;

                if (!search) {
                    search = this.search ? this.search : null
                }
                if (!user) {
                    user = this.user
                }

                if (this.onlyMy) {
                    user = this.$currentUser.id;
                }

                if (this.isMobile) {
                    this.pageSize = 10;
                }

                SourcesService.getSources(page, sort, search, range, user, false, this.group, this.pageSize)
                    .then(sources => {
                        this.pager = sources;
                        this.sources = sources.data
                    })

            },
            selectRange(event) {
                this.range = event;
            },
            resetFilters() {
                this.search = '';
                this.sortBy = 'updated_at';
                this.sortDesc = true;
                this.sortDirection = 'desc';
                this.user = null;
                this.range = {
                    start: null,
                    end: null
                };
                this.group = [];
                this.onlyMy = false;
                //re-initialize element
                this.dateRange++;

                this.getSources();
            },
            getUsers() {
                OffersService.getUsers()
                    .then(users => {
                        let usersArray = [];

                        users.forEach(function (userItem) {
                            let user = {};
                            user.value = userItem.id;
                            user.text = userItem.name;
                            usersArray.push(user);
                        });

                        this.users = usersArray
                    })
            },
            edit(item) {
                this.selectedSource = item
                this.$refs.sourceEditModal.show()
            },
            canEditSource(source) {
                if (!source || !source.item) {
                    return false;
                }

                return source.item.user_id == this.$currentUser.id || this.$currentUser.role == 'admin';
            },
            deleteSource(source) {
              this.$bvModal.msgBoxConfirm('ID: ' + source.id + ' Название: ' + source.title , {
                title: 'Вы точно уверены, что хотите удалить?',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'danger',
                okTitle: 'ДА',
                cancelTitle: 'НЕТ',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
              })
                .then(value => {
                  if(value !== true) {
                    return
                  }

                  if(! confirm('Точно удаляем?')) {
                    return;
                  }
                  SourcesService.deleteSource(source.id)
                    .then(response => {
                      if (response.success) {
                        this.getSources();

                        toastr.success('Источник удалён!')
                      } else {
                        toastr.error('Вы не можете удалить этот источник. К нему привязаны данные.')
                      }
                    })
                })
                .catch(err => {
                })
            },
            handleResize() {
                this.window.width = window.innerWidth;
                this.window.height = window.innerHeight;

                if (this.window.width < 415) {
                    this.isMobile = true
                } else {
                    this.isMobile = false
                }

                if (this.window.width > 1199) {
                    this.isXl = true
                } else {
                    this.isXl = false
                }
            },
            hideCreateModal() {
                this.getSources();

                this.$refs.sourceCreateModal.hide()
            },
            getGroups() {
                SourcesService.getGroups()
                    .then(function (groups) {
                        this.groups = groups;
                    }.bind(this))
            },
        },
        beforeMount() {
            this.getSources()
            this.getUsers()
            this.getGroups();
        },
        created() {
            window.addEventListener('resize', this.handleResize)
            this.handleResize();
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize)
        },
    }
</script>
<style>
    .btn i {
        text-align: center !important;
    }

    .popover-body {
        max-height: 200px;
        overflow: scroll;
    }

    .vdp-datepicker input {
        background-color: white !important;
        width: 100% !important;
    }

    .dateFrom {
        border-bottom-right-radius: 0 !important;
        border-top-right-radius: 0 !important;
    }

    .dateTo {
        border-bottom-left-radius: 0 !important;
        border-top-left-radius: 0 !important;
    }

    .filterComponent {
        height: 30px !important;
    }

    .filterComponent .vs__dropdown-toggle {
        height: 30px !important;
    }

    .filterComponent .input-date {
        height: 30px !important;
    }

    .filterComponent .dateFrom {
        height: 30px !important;
    }

    .filterComponent .dateTo {
        height: 30px !important;
    }

    .input-date {
        border-top-left-radius: 0.2rem !important;
        border-bottom-left-radius: 0.2rem !important;
    }

    .mainButton {
        width: 100%;
    }

    .date {
        width: 100%;
    }

    .datePickerXl {
        min-width: 100% !important;
        max-width: 100% !important;
    }

    .input-group-append {
        width: 100%;
    }

    .myOffers {
        padding-top: 4px;
    }

    .groupComponent .vs__selected {
        margin: 2px 2px 4px 0 !important;
    }

    .table-sm th {
        padding-left: 0.5rem;
        padding-right: 0.5rem;
    }

    .table.b-table > tfoot > tr > th[aria-sort]::before, .table.b-table > thead > tr > th[aria-sort]::before {
        padding-left: 5px;
        width: .2em;
    }

    @media (max-width: 576px) {
        .dateRight .vdp-datepicker__calendar {
            right: 0 !important;
        }
    }

    @media (min-width: 768px) {
        .dateLeft .vdp-datepicker__calendar {
            right: 0 !important;
        }

        .dateRight .vdp-datepicker__calendar {
            right: 0 !important;
        }
    }

    @media (min-width: 1200px) {
        .myOffers {
            max-width: 14.76666667% !important;
        }

        .input-date {
            width: 146px !important;
        }
    }

    @media (min-width: 1300px) {
        .input-date {
            width: 160px !important;
        }
    }

    @media (min-width: 1400px) {
        .input-date {
            width: 170px !important;
        }

        .myOffers {
            max-width: 12.66666667% !important;
        }
    }

    @media (min-width: 1500px) {
        .input-date {
            width: 190px !important;
        }
    }

    @media (min-width: 1600px) {
        .input-date {
            width: 200px !important;
        }

        .myOffers {
            max-width: 11.46666667% !important;
        }
    }

    @media (min-width: 1700px) {
        .input-date {
            width: 220px !important;
        }
    }

    @media (min-width: 1800px) {
        .input-date {
            width: 230px !important;
        }
    }

    @media (min-width: 1900px) {
        .input-date {
            width: 240px !important;
        }

        .myOffers {
            max-width: 8.66666667% !important;
        }
    }

</style>



// WEBPACK FOOTER //
// resources/js/views/front/Sources.vue